/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Publication readership band used for pricing.
 */
export type PublicationAudience = typeof PublicationAudience[keyof typeof PublicationAudience];


export const PublicationAudience = {
  general: 'general',
  child: 'child',
} as const;
